import React from "react"
import { Link as GatsbyLink } from "gatsby"

const Link = ({ to, ...props }) => {
  const external = to.startsWith("https://") || to.startsWith("http://")
  if (!external) {
    return <GatsbyLink to={to} {...props} />
  } else {
    const newTab = !to.startsWith("https://app.teamspective.com")
    return <a {...props} href={to} target={newTab ? "_blank" : undefined} />
  }
}

export default Link
